import { deliveryRateOf, type PerformanceReport } from '../dashboard/performance.ts';

export const REAL_RATES_DAYS = 30;

const PERCENT = 100;

export type RealRates = { readonly confirmationRate: number | null; readonly deliveryRate: number | null };

export const realRatesOf = (report: PerformanceReport): RealRates => {
  const delivery = deliveryRateOf(report.orders);
  const { created, confirmed } = report.orders;
  return {
    confirmationRate: created === 0 ? null : Math.min(1, confirmed / created) * PERCENT,
    deliveryRate: delivery === null ? null : delivery * PERCENT,
  };
};
